import {initLanguage} from "@/modules/language/language";
import {hideAllInfo, hideLayerInfoForm} from "@/helpers/layer/info/layer-info-helper";

/**
 * Hide all elements by selector
 *
 * @param selector
 */
export function hideElementsBySelector(selector) {
    document.querySelectorAll(selector).forEach(element => {
        element.classList.add('d-none')
    })
}

/**
 * Hide all elements by data attribute
 * Ivo
 *
 * @param attribute
 * @param value
 * @param secondAttribute
 * @param secondValue
 */
export function hideElementsByDataAttribute(attribute, value, secondAttribute = undefined, secondValue = undefined) {
    let selector = `[${attribute}="${value}"]`;

    if (secondAttribute && secondValue) {
        selector += `[${secondAttribute}="${secondValue}"]`;
    }

    document.querySelectorAll(selector).forEach(element => {
        element.classList.add('d-none');
    });
}

/**
 * Show all elements by selector
 *
 * @param selector
 */
export function showElementsBySelector(selector) {
    document.querySelectorAll(selector).forEach(element => {
        element.classList.remove('d-none')
    })
}

/**
 * Show all elements by data attribute
 * Ivo
 *
 * @param attribute
 * @param value
 * @param secondAttribute
 * @param secondValue
 */
export function showElementsByDataAttribute(attribute, value, secondAttribute = undefined, secondValue = undefined) {
    let selector = `[${attribute}="${value}"]`;

    if (secondAttribute && secondValue) {
        selector += `[${secondAttribute}="${secondValue}"]`;
    }

    document.querySelectorAll(selector).forEach(element => {
        element.classList.remove('d-none');
    });
}

/**
 * Hide element by selector
 *
 * @param selector
 * @param innerHTML
 */
export function setInnerHtmlBySelector(selector, innerHTML) {
    document.querySelector(selector).innerHTML = innerHTML
}

/**  Hide element by selector
 *
 * @param selector
 */
export function isVisibleBySelector(selector) {
    return document.querySelector(selector).getBoundingClientRect().width > 0
}

/**
 * Hide element by selector
 *
 * @param selector
 */
export function removeElementBySelector(selector) {
    document.querySelector(selector).remove()
}

/**
 * Hide element by selector
 *
 * @param selector
 */
export function addHtmlBySelector(selector, innerHtml, position = 'beforeend') {
    document.querySelector(selector).insertAdjacentHTML(position, innerHtml);

    initLanguage()
}

/**
 * Remove all elements by selector
 *
 * @param selector
 */
export function removeElementsBySelector(selector) {
    document.querySelectorAll(selector).forEach(element => {
        element.remove()
    })
}


export function getValueBySelector(selector) {
    let element = document.querySelector(selector)
    if(element) {
        return element.value
    }
    return ''
}

export function setValueBySelector(selector, value) {
    document.querySelector(selector).value = value
}

export function getBySelector(selector) {
    return document.querySelector(selector)
}

export function getAllBySelector(selector) {
    return document.querySelectorAll(selector)
}

export function removeClassBySelector(selector, className) {
    document.querySelectorAll(selector).forEach(element => {
        element.classList.remove(className)
    })
}

export function addClassBySelector(selector, className) {
    document.querySelectorAll(selector).forEach(element => {
        element.classList.add(className)
    })
}

export function clearHtmlBySelector(selector) {
    const element = document.querySelector(selector)
    if(element) {
        element.innerHTML = ''
    }
}

export function unEscapeOutput(toOutput) {

    if (toOutput === undefined || toOutput === null || toOutput === '') {
        return '';
    }

    toOutput = toOutput.toString();

    return toOutput.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&nbsp;/g, ' ')
}

export function getInnerHtmlByText(text, depth) {
    let tempDiv = document.createElement('div');
    tempDiv.innerHTML = text;

    if(depth) {
        for(let i = 0; i < depth; i++) {
            tempDiv = tempDiv.firstChild
        }
    }

    return tempDiv.innerHTML;
}

export function getHtmlByText(text, data) {
    let tempDiv = document.createElement('div');
    tempDiv.innerHTML = text;

    return tempDiv.firstChild
}

export function toggleHeaderBySelector(selector, show = undefined) {
    const element = document.querySelectorAll(selector)[0]
    const classList = [...element.classList]

    hideLayerInfoForm()

    if(classList.includes('d-none') || show) {
        element.classList.remove('d-none')
        element.parentNode.classList.remove('d-none')
    } else {
        hideAllInfo()
    }
}

export function addClassByElement(element, className) {
    element.classList.add(className)
}

/**
 * disable all elements by selector
 *
 * @param selector
 */
export function disableElementsBySelector(selector) {
    document.querySelectorAll(selector).forEach(element => {
        element.disabled = true
    })
}
/**
 * enable all elements by selector
 *
 * @param selector
 */
export function enableElementsBySelector(selector) {
    document.querySelectorAll(selector).forEach(element => {
        element.disabled = false
    })
}
